module.exports = __webpack_public_path__ + "img/7.e65d634f.png";